module.exports = __webpack_public_path__ + "img/elite_taupe_ba_list.c4847036.jpg";